var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 7.75C61.4807 7.75 73.625 19.8943 73.625 34.875C73.625 42.2646 70.6701 48.964 65.8774 53.8561L65.8719 82.3445C65.8719 84.5607 63.5213 85.911 61.6395 84.9322L61.2928 84.721L46.4963 74.3058L31.7078 84.7206C29.8956 85.9968 27.4379 84.852 27.155 82.7496L27.1281 82.3445L27.1226 53.8561C22.3299 48.964 19.375 42.2646 19.375 34.875C19.375 19.8943 31.5193 7.75 46.5 7.75ZM60.0594 76.7448L60.0602 58.3725C56.071 60.6796 51.4397 62 46.5 62C41.5603 62 36.929 60.6796 32.9398 58.3725L32.9406 76.7431L44.8225 68.3754C45.7005 67.757 46.8356 67.6796 47.778 68.1432L48.1687 68.375L60.0594 76.7448ZM46.5 13.5625C34.7294 13.5625 25.1875 23.1044 25.1875 34.875C25.1875 46.6456 34.7294 56.1875 46.5 56.1875C58.2706 56.1875 67.8125 46.6456 67.8125 34.875C67.8125 23.1044 58.2706 13.5625 46.5 13.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.7191388cec625cb642674d112b11be18.svg";
export { ForwardRef as ReactComponent };